export const BlurSpan = ({ children }) => {
  return (
    <span
      style={{
        color: "transparent",
        textShadow: "rgba(0, 0, 0, 0.5) 0px 0px 8px",
        userSelect: "none",
      }}>
      {children}
    </span>
  );
};
